import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'email-confirmation.title',
    defaultMessage: 'Enter your password to confirm your updated email',
  },
  emailLabel: {
    id: 'account.verification.form.emailField.label',
    defaultMessage: 'Updated email',
    description:
      'The label shown above a disabled email field when the user is confirming that they have updated their email.',
  },
  incorrectPassword: {
    id: 'email-confirmation.form.incorrect-password',
    defaultMessage: 'Your password was incorrect',
  },
  invalidTokenTitle: {
    id: 'email-confirmation.invalid-token.title',
    defaultMessage: 'Unable to verify your email address',
  },
  invalidTokenDescription: {
    id: 'email-confirmation.invalid-token.description',
    defaultMessage:
      'Something went wrong while trying to validate your email. The link you followed may have expired or be broken. Please log in to try again.',
  },
  invalidTokenReturnToLoginButton: {
    id: 'email-confirmation.invalid-token.return-login-button',
    defaultMessage: 'Return to log in',
  },
});
